import type { Partner } from 'BrokerTsLib/src/enums'

import type { Environment } from '../AppSettings'
import { AllianzKontakt } from './AllianzKontakt'
import { AndyAuto } from './AndyAuto'
import { BmwFs } from './BmwFs'
import { BusinessLease } from './BusinessLease'
import { CommonClient, LeasePlan, LeasingCS, UniCreditLeasing } from './CommonClient'
import { Davocar } from './Davocar'
import { AutoEsa, DirectAuto, Essox } from './Essox'
import { Jap } from './Jap'
import { Kapitol } from './Kapitol'
import { Respect } from './Respect'
import { RLCZ } from './RLCZ'
import { TUkas } from './TUkas'
import { VWFS } from './VWFS'

export * from './BusinessLease'
export * from './CommonClient'
export * from './Jap'
export * from './Kapitol'
export * from './Respect'
export * from './RLCZ'
export * from './TUkas'

export const Partners = [CommonClient, Jap, Kapitol, BmwFs, Respect, AndyAuto, LeasePlan, Davocar, AllianzKontakt, Essox, AutoEsa, DirectAuto, RLCZ, BusinessLease, TUkas, UniCreditLeasing, LeasingCS, VWFS]

export interface IPartnerSettings {
  partner: keyof typeof Partner
  origAppUrl: {
    // kvuli login page, mailum apod..
    [Key in Environment]?: string
  }
  hosts: string[] // pro detekci partnera na zaklade URL
  deployment?: keyof typeof Partner // pro nastaveni spravneho environmentu pro partnerske deploye (JAP, KAP, ESSOX...)
  logo?: string // pro zobrazeni loga partnera
}

export const getPartnerByHost = (): IPartnerSettings | undefined => {
  return Partners.find((x) => x.hosts.indexOf(window.window.location.host) >= 0)
}

export const getPartnerByKey = (
  key: keyof typeof Partner,
): IPartnerSettings | undefined => {
  return Partners.find((x) => x.partner == key)
}
